module.exports = __webpack_public_path__ + "img/4.1aed99f5.png";